import { Directive, Self, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';
import { filter } from 'rxjs/operators/filter';

import { FeatureService } from '../shared';
import { FeatureDetailsComponent } from './feature-details.component';


@Directive({
  selector: '[igoFeatureDetailsBinding]'
})
export class FeatureDetailsBindingDirective implements OnInit, OnDestroy {

  private component: FeatureDetailsComponent;
  private focusedFeatures$$: Subscription;

  constructor(@Self() component: FeatureDetailsComponent,
              private featureService: FeatureService) {
    this.component = component;
  }

  ngOnInit() {
    this.focusedFeatures$$ = this.featureService.focusedFeature$.pipe(
      filter(feature => feature !== undefined)
    ).subscribe(feature => this.component.feature = feature);
  }

  ngOnDestroy() {
    this.focusedFeatures$$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/feature-details/feature-details-binding.directive.ts